import React from "react";
import { useLocation } from "react-router-dom";
import Navigation, { getContainerClass } from "../../components/navigation/navigation";
import Cover from "../../components/cover/cover";
import Facilities from "../../components/facilities/facilities";
// import Header from "../../components/header/header";

const FacilityPage = () => {
  const breadcrumb = ["Home", "Facilities"];
  const location = useLocation();

  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header /> */}
        <Cover breadcrumb={breadcrumb} page="facilities" />
        <Facilities />
      </div>
    </>
  );
};

export default FacilityPage;
